export default __webpack_public_path__ + "static/media/global-value.96767ff4.jpeg";